import { render, staticRenderFns } from "./TemplateMiniature.vue?vue&type=template&id=266c319e&scoped=true&"
import script from "./TemplateMiniature.vue?vue&type=script&lang=js&"
export * from "./TemplateMiniature.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMiniature.vue?vue&type=style&index=0&id=266c319e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266c319e",
  null
  
)

export default component.exports